import React, { useEffect } from 'react';
import { Row } from 'antd';
import cardOutline from "../../assets/images/card-outline.svg";
import cashOutline from "../../assets/images/cash-outline.svg";
import documentOutline from "../../assets/images/document-outline.svg";
import tagOutline from "../../assets/images/pricetag-outline.svg";
import { StepFormProps } from '../../types/types';
import { ConnectionCard } from '../contents/connection-card';


export const Connections: React.FC<StepFormProps> = ( props ) => {
    /*const { getCodatRedirect } = useIntegrations();*/
    const companyId = localStorage.getItem('companyId');

    //  const [url, setURL] = useState<string>();

    useEffect(() => {

    }, [companyId]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
      <Row gutter={[16, 16]}>
        <ConnectionCard title={'Accounting'} tooltip={'Accounting'} connected={'Not connected'} icon={cashOutline}
                        button={'Connect'}/>
        <ConnectionCard title={'Banking'} tooltip={'Banking'} connected={'Not connected'} icon={cardOutline}
                        button={'Connect'}/>
        <ConnectionCard title={'Commerce'} tooltip={'Commerce'} connected={'Not connected'} icon={tagOutline}
                        button={'Connect'} optional={true}/>
        <ConnectionCard title={'Business Documents'} tooltip={'Documents'} connected={'Not connected'} icon={documentOutline}
                        button={'Upload'}/>

      </Row>
    );
  }
;
